export default __webpack_public_path__ + "static/media/lock-icon.8d4041f3.svg";